export const getAverageScoreScaleCellClassName = (testId, index) => {
  // Tests with exceptional average score scales
  switch (testId) {
    // Illustrait, WAA, Emotify v2
    case 48:
    case 50:
    case 59:  
    case 51: {
      switch (true) {
        case index < 2:
          return "orange-striped";
        case index >= 2 && index < 5:
          return "orange";
        case index >= 5 && index < 15:
          return "light-green";
        case index >= 15 && index < 18:
          return "green";
        default:
          return "dark-green";
      }
    }
    // Excel 365, Word 365, PowerPoint 365, CLPT
    case 53:
    case 54:
    case 55:
    case 57: {
      switch (true) {
        case index < 4:
          return "orange-striped";
        case index >= 4 && index < 8:
          return "orange";
        case index >= 8 && index < 12:
          return "light-green";
        case index >= 12 && index < 16:
          return "green";
        default:
          return "dark-green";
      }
    }
    default:
      break;
  }

  // Standard average score scale
  switch (true) {
    case index < 2:
      return "orange-striped";
    case index >= 2 && index < 4:
      return "orange";
    case index >= 4 && index < 16:
      return "light-green";
    case index >= 16 && index < 18:
      return "green";
    default:
      return "dark-green";
  }
};

export const getAverageScoreScaleBrackets = (testId) => {
  // format - {label: bracket width}
  switch (testId) {
    case 48:
    case 50:
    case 59:     
    case 51: {
      return {
        "Far Below Average": 10,
        "Below Average": 15,
        Average: 50,
        "Above Average": 15,
        "Far Above Average": 10,
      };
    }
    case 53:
    case 54:
    case 55:
    case 57: {
      return {
        Beginner: 20,
        Foundational: 20,
        Intermediate: 20,
        Skilled: 20,
        Advanced: 20,
      };
    }
    default: {
      return {
        "Far Below Average": 10,
        "Below Average": 10,
        Average: 60,
        "Above Average": 10,
        "Far Above Average": 10,
      };
    }
  }
};
